import { gql } from '@apollo/client';

export const CREATE_IMAGE_UPLOAD = gql`
    mutation CreateImageUpload($fileName: String!, $contentType: String, $durationSeconds: Float) {
        createImageUpload(fileName: $fileName, contentType: $contentType, durationSeconds: $durationSeconds) {
            image { id url }
            uploadUrl
        }
    }
`;
